// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type ActivityHistoryQueryVariables = PrivateSchemaTypes.Exact<{
  filters: PrivateSchemaTypes.UserActivityHistoryInput;
}>;


export type ActivityHistoryQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'UserModelSelf' }
    & Pick<PrivateSchemaTypes.UserModelSelf, 'id'>
    & { activityHistory: (
      { __typename?: 'UserActivityHistory' }
      & Pick<PrivateSchemaTypes.UserActivityHistory, 'count'>
      & { items: Array<(
        { __typename?: 'TopicEnrolmentModelAsStudent' }
        & ActivityTopicDataFragment
      ) | (
        { __typename: 'UserEventModel' }
        & Pick<PrivateSchemaTypes.UserEventModel, 'id' | 'isCpdEntry'>
        & { certification?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CertificationModel' }
          & Pick<PrivateSchemaTypes.CertificationModel, 'id' | 'name'>
        )>, event: (
          { __typename?: 'EventModel' }
          & Pick<PrivateSchemaTypes.EventModel, 'deleted_at' | 'id' | 'title' | 'start_time' | 'end_time'>
        ) }
      ) | (
        { __typename?: 'CPDManualEntryModel' }
        & ActivityCpdDataFragment
      )> }
    ) }
  ) }
);

export type CpdAggregatesQueryVariables = PrivateSchemaTypes.Exact<{
  from: PrivateSchemaTypes.Scalars['JSON'];
  to: PrivateSchemaTypes.Scalars['JSON'];
  fromDateTime: PrivateSchemaTypes.Scalars['DateTime'];
  toDateTime: PrivateSchemaTypes.Scalars['DateTime'];
}>;


export type CpdAggregatesQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'UserModelSelf' }
    & Pick<PrivateSchemaTypes.UserModelSelf, 'totalManualCpdHours' | 'totalHoursSpentInEvents' | 'totalHoursSpentInResources' | 'cpdManualEntriesCount'>
    & { cpdTotalHoursSpentInEvents: PrivateSchemaTypes.UserModelSelf['totalHoursSpentInEvents'], cpdTotalHoursSpentInResources: PrivateSchemaTypes.UserModelSelf['totalHoursSpentInResources'], completedEventInvitationsCount: PrivateSchemaTypes.UserModelSelf['eventInvitationsCount'], inProgressEventInvitationsCount: PrivateSchemaTypes.UserModelSelf['eventInvitationsCount'], failedTopicEnrolmentsCount: PrivateSchemaTypes.UserModelSelf['topicEnrolmentsCount'], completedTopicEnrolmentsCount: PrivateSchemaTypes.UserModelSelf['topicEnrolmentsCount'], inProgressCount: PrivateSchemaTypes.UserModelSelf['topicEnrolmentsCount'] }
  ) }
);

export type AddCpdEntryMutationVariables = PrivateSchemaTypes.Exact<{
  input: PrivateSchemaTypes.CpdManualEntryModelInput;
}>;


export type AddCpdEntryMutation = (
  { __typename?: 'Mutation' }
  & { me: (
    { __typename?: 'UserModelSelfMutation' }
    & Pick<PrivateSchemaTypes.UserModelSelfMutation, 'id'>
    & { createCPDEntry?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CPDManualEntryModel' }
      & Pick<PrivateSchemaTypes.CpdManualEntryModel, 'id'>
    )> }
  ) }
);

export type DeleteCpdEntryMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type DeleteCpdEntryMutation = (
  { __typename?: 'Mutation' }
  & { me: (
    { __typename?: 'UserModelSelfMutation' }
    & Pick<PrivateSchemaTypes.UserModelSelfMutation, 'id'>
    & { cpdManualEntry?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CPDManualEntryModel' }
      & Pick<PrivateSchemaTypes.CpdManualEntryModel, 'id' | 'delete'>
    )> }
  ) }
);

export type PatchCpdEntryMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.CpdManualEntryModelInput;
}>;


export type PatchCpdEntryMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { user?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.UserModelAsAdminMutations, 'id'>
      & { cpdManualEntry?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CPDManualEntryModel' }
        & Pick<PrivateSchemaTypes.CpdManualEntryModel, 'id'>
        & { patch?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CPDManualEntryModel' }
          & Pick<PrivateSchemaTypes.CpdManualEntryModel, 'id' | 'name' | 'description' | 'number_of_minutes' | 'document_cdn_url' | 'date_completed' | 'date_started' | 'source'>
        )> }
      )> }
    )> }
  )> }
);

export type MarkItemsAsCpdMutationVariables = PrivateSchemaTypes.Exact<{
  cpdInput: Array<PrivateSchemaTypes.CpdBatchItemInput> | PrivateSchemaTypes.CpdBatchItemInput;
}>;


export type MarkItemsAsCpdMutation = (
  { __typename?: 'Mutation' }
  & { me: (
    { __typename?: 'UserModelSelfMutation' }
    & Pick<PrivateSchemaTypes.UserModelSelfMutation, 'id' | 'batchMarkItemsAsCPD'>
  ) }
);

export type ActivityTopicDataFragment = (
  { __typename: 'TopicEnrolmentModelAsStudent' }
  & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'deleted_at' | 'status' | 'id' | 'isCpdEntry' | 'topic_id' | 'target_completion_date' | 'auto_correct' | 'auto_incorrect' | 'pass_mark' | 'available_points' | 'lastViewedAt' | 'readDurationSeconds' | 'share_batch_ts'>
  & { started_at: PrivateSchemaTypes.TopicEnrolmentModelAsStudent['start_date'], completed_at: PrivateSchemaTypes.TopicEnrolmentModelAsStudent['completion_date'], topic_enrolment_status: PrivateSchemaTypes.TopicEnrolmentModelAsStudent['status'] }
  & { sharedBy?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'UserModelBase' }
    & Pick<PrivateSchemaTypes.UserModelBase, 'id' | 'account_name' | 'display_name' | 'email'>
  )>, originSection?: PrivateSchemaTypes.Maybe<(
    { __typename: 'PathwayModelAsStudent' }
    & Pick<PrivateSchemaTypes.PathwayModelAsStudent, 'id' | 'title' | 'deleted_at'>
  ) | (
    { __typename: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id' | 'name' | 'deleted_at'>
  ) | (
    { __typename: 'CertificationModelAsStudent' }
    & Pick<PrivateSchemaTypes.CertificationModelAsStudent, 'id' | 'name' | 'deleted_at'>
  )>, topic: (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'deleted_at'>
  ), topicVersion?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicVersionModel' }
    & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'version' | 'title'>
  )> }
);

export type ActivityCpdDataFragment = (
  { __typename: 'CPDManualEntryModel' }
  & Pick<PrivateSchemaTypes.CpdManualEntryModel, 'id' | 'date_started' | 'date_completed' | 'name' | 'description' | 'numberOfSeconds' | 'created_at' | 'source' | 'document_cdn_url' | 'fileName'>
);

export type ActivityCpdGroupPermissionQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type ActivityCpdGroupPermissionQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'UserModelSelf' }
    & Pick<PrivateSchemaTypes.UserModelSelf, 'isMemberOfCPDGroup'>
  ) }
);

export const ActivityTopicDataFragmentDoc = gql`
    fragment ActivityTopicData on TopicEnrolmentModelAsStudent {
  __typename
  deleted_at
  status
  id
  isCpdEntry
  topic_id
  target_completion_date
  started_at: start_date
  completed_at: completion_date
  auto_correct
  auto_incorrect
  pass_mark
  available_points
  lastViewedAt
  topic_enrolment_status: status
  readDurationSeconds
  sharedBy {
    id
    account_name
    display_name
    email
  }
  share_batch_ts
  originSection {
    __typename
    ... on PathwayModelAsStudent {
      id
      title
      deleted_at
    }
    ... on WorkspaceModelAsMember {
      id
      name
      deleted_at
    }
    ... on CertificationModelAsStudent {
      id
      name
      deleted_at
    }
  }
  topic {
    id
    deleted_at
  }
  topicVersion {
    id
    version
    title
  }
}
    `;
export const ActivityCpdDataFragmentDoc = gql`
    fragment ActivityCPDData on CPDManualEntryModel {
  __typename
  id
  date_started
  date_completed
  name
  description
  numberOfSeconds
  created_at
  source
  document_cdn_url
  fileName
}
    `;
export const ActivityHistoryDocument = gql`
    query activityHistory($filters: UserActivityHistoryInput!) {
  me {
    id
    activityHistory(filters: $filters) {
      count
      items {
        ... on UserEventModel {
          __typename
          id
          isCpdEntry
          certification {
            id
            name
          }
          event {
            deleted_at
            id
            title
            start_time
            end_time
          }
        }
        ...ActivityTopicData
        ...ActivityCPDData
      }
    }
  }
}
    ${ActivityTopicDataFragmentDoc}
${ActivityCpdDataFragmentDoc}`;

/**
 * __useActivityHistoryQuery__
 *
 * To run a query within a React component, call `useActivityHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityHistoryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useActivityHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ActivityHistoryQuery, ActivityHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivityHistoryQuery, ActivityHistoryQueryVariables>(ActivityHistoryDocument, options);
      }
export function useActivityHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivityHistoryQuery, ActivityHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivityHistoryQuery, ActivityHistoryQueryVariables>(ActivityHistoryDocument, options);
        }
export type ActivityHistoryQueryHookResult = ReturnType<typeof useActivityHistoryQuery>;
export type ActivityHistoryLazyQueryHookResult = ReturnType<typeof useActivityHistoryLazyQuery>;
export type ActivityHistoryQueryResult = Apollo.QueryResult<ActivityHistoryQuery, ActivityHistoryQueryVariables>;
export const CpdAggregatesDocument = gql`
    query cpdAggregates($from: JSON!, $to: JSON!, $fromDateTime: DateTime!, $toDateTime: DateTime!) {
  me {
    totalManualCpdHours(from: $fromDateTime, to: $toDateTime)
    totalHoursSpentInEvents(from: $fromDateTime, to: $toDateTime)
    totalHoursSpentInResources(from: $fromDateTime, to: $toDateTime)
    cpdTotalHoursSpentInEvents: totalHoursSpentInEvents(
      from: $fromDateTime
      to: $toDateTime
      cpdOnly: true
    )
    cpdTotalHoursSpentInResources: totalHoursSpentInResources(
      from: $fromDateTime
      to: $toDateTime
      cpdOnly: true
    )
    cpdManualEntriesCount(
      filters: [{name: dateStartedBetween, value: [$from, $to]}]
    )
    completedEventInvitationsCount: eventInvitationsCount(
      filters: [{name: attendanceRecord, value: true}, {name: eventStartedBetween, value: [$from, $to]}, {name: eventAlreadyEnded}, {name: eventIsNotDeleted}]
    )
    inProgressEventInvitationsCount: eventInvitationsCount(
      filters: [{name: attendanceRecord, value: true}, {name: eventStartedBetween, value: [$from, $to]}, {name: eventIsInProgress}, {name: eventIsNotDeleted}]
    )
    failedTopicEnrolmentsCount: topicEnrolmentsCount(
      filters: [{name: startedInInterval, value: [$from, $to]}, {name: failed}, {name: includeDeleted}]
    )
    completedTopicEnrolmentsCount: topicEnrolmentsCount(
      filters: [{name: startedInInterval, value: [$from, $to]}, {name: completed}, {name: includeDeleted}]
    )
    inProgressCount: topicEnrolmentsCount(
      filters: [{name: startedInInterval, value: [$from, $to]}, {name: inProgress}, {name: includeDeleted}]
    )
  }
}
    `;

/**
 * __useCpdAggregatesQuery__
 *
 * To run a query within a React component, call `useCpdAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCpdAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCpdAggregatesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      fromDateTime: // value for 'fromDateTime'
 *      toDateTime: // value for 'toDateTime'
 *   },
 * });
 */
export function useCpdAggregatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CpdAggregatesQuery, CpdAggregatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CpdAggregatesQuery, CpdAggregatesQueryVariables>(CpdAggregatesDocument, options);
      }
export function useCpdAggregatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CpdAggregatesQuery, CpdAggregatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CpdAggregatesQuery, CpdAggregatesQueryVariables>(CpdAggregatesDocument, options);
        }
export type CpdAggregatesQueryHookResult = ReturnType<typeof useCpdAggregatesQuery>;
export type CpdAggregatesLazyQueryHookResult = ReturnType<typeof useCpdAggregatesLazyQuery>;
export type CpdAggregatesQueryResult = Apollo.QueryResult<CpdAggregatesQuery, CpdAggregatesQueryVariables>;
export const AddCpdEntryDocument = gql`
    mutation AddCPDEntry($input: CPDManualEntryModelInput!) {
  me {
    id
    createCPDEntry(input: $input) {
      id
    }
  }
}
    `;
export type AddCpdEntryMutationFn = Apollo.MutationFunction<AddCpdEntryMutation, AddCpdEntryMutationVariables>;

/**
 * __useAddCpdEntryMutation__
 *
 * To run a mutation, you first call `useAddCpdEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCpdEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCpdEntryMutation, { data, loading, error }] = useAddCpdEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCpdEntryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddCpdEntryMutation, AddCpdEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddCpdEntryMutation, AddCpdEntryMutationVariables>(AddCpdEntryDocument, options);
      }
export type AddCpdEntryMutationHookResult = ReturnType<typeof useAddCpdEntryMutation>;
export type AddCpdEntryMutationResult = Apollo.MutationResult<AddCpdEntryMutation>;
export type AddCpdEntryMutationOptions = Apollo.BaseMutationOptions<AddCpdEntryMutation, AddCpdEntryMutationVariables>;
export const DeleteCpdEntryDocument = gql`
    mutation DeleteCPDEntry($id: PositiveInt!) {
  me {
    id
    cpdManualEntry(id: $id) {
      id
      delete
    }
  }
}
    `;
export type DeleteCpdEntryMutationFn = Apollo.MutationFunction<DeleteCpdEntryMutation, DeleteCpdEntryMutationVariables>;

/**
 * __useDeleteCpdEntryMutation__
 *
 * To run a mutation, you first call `useDeleteCpdEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCpdEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCpdEntryMutation, { data, loading, error }] = useDeleteCpdEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCpdEntryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCpdEntryMutation, DeleteCpdEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCpdEntryMutation, DeleteCpdEntryMutationVariables>(DeleteCpdEntryDocument, options);
      }
export type DeleteCpdEntryMutationHookResult = ReturnType<typeof useDeleteCpdEntryMutation>;
export type DeleteCpdEntryMutationResult = Apollo.MutationResult<DeleteCpdEntryMutation>;
export type DeleteCpdEntryMutationOptions = Apollo.BaseMutationOptions<DeleteCpdEntryMutation, DeleteCpdEntryMutationVariables>;
export const PatchCpdEntryDocument = gql`
    mutation PatchCPDEntry($id: PositiveInt!, $userId: PositiveInt!, $input: CPDManualEntryModelInput!) {
  admin {
    user(id: $userId) {
      id
      cpdManualEntry(id: $id) {
        id
        patch(input: $input) {
          id
          name
          description
          number_of_minutes
          document_cdn_url
          date_completed
          date_started
          source
        }
      }
    }
  }
}
    `;
export type PatchCpdEntryMutationFn = Apollo.MutationFunction<PatchCpdEntryMutation, PatchCpdEntryMutationVariables>;

/**
 * __usePatchCpdEntryMutation__
 *
 * To run a mutation, you first call `usePatchCpdEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchCpdEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchCpdEntryMutation, { data, loading, error }] = usePatchCpdEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatchCpdEntryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PatchCpdEntryMutation, PatchCpdEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PatchCpdEntryMutation, PatchCpdEntryMutationVariables>(PatchCpdEntryDocument, options);
      }
export type PatchCpdEntryMutationHookResult = ReturnType<typeof usePatchCpdEntryMutation>;
export type PatchCpdEntryMutationResult = Apollo.MutationResult<PatchCpdEntryMutation>;
export type PatchCpdEntryMutationOptions = Apollo.BaseMutationOptions<PatchCpdEntryMutation, PatchCpdEntryMutationVariables>;
export const MarkItemsAsCpdDocument = gql`
    mutation MarkItemsAsCPD($cpdInput: [CPDBatchItemInput!]!) {
  me {
    id
    batchMarkItemsAsCPD(input: $cpdInput)
  }
}
    `;
export type MarkItemsAsCpdMutationFn = Apollo.MutationFunction<MarkItemsAsCpdMutation, MarkItemsAsCpdMutationVariables>;

/**
 * __useMarkItemsAsCpdMutation__
 *
 * To run a mutation, you first call `useMarkItemsAsCpdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkItemsAsCpdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markItemsAsCpdMutation, { data, loading, error }] = useMarkItemsAsCpdMutation({
 *   variables: {
 *      cpdInput: // value for 'cpdInput'
 *   },
 * });
 */
export function useMarkItemsAsCpdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkItemsAsCpdMutation, MarkItemsAsCpdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkItemsAsCpdMutation, MarkItemsAsCpdMutationVariables>(MarkItemsAsCpdDocument, options);
      }
export type MarkItemsAsCpdMutationHookResult = ReturnType<typeof useMarkItemsAsCpdMutation>;
export type MarkItemsAsCpdMutationResult = Apollo.MutationResult<MarkItemsAsCpdMutation>;
export type MarkItemsAsCpdMutationOptions = Apollo.BaseMutationOptions<MarkItemsAsCpdMutation, MarkItemsAsCpdMutationVariables>;
export const ActivityCpdGroupPermissionDocument = gql`
    query ActivityCPDGroupPermission {
  me {
    isMemberOfCPDGroup
  }
}
    `;

/**
 * __useActivityCpdGroupPermissionQuery__
 *
 * To run a query within a React component, call `useActivityCpdGroupPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityCpdGroupPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityCpdGroupPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityCpdGroupPermissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActivityCpdGroupPermissionQuery, ActivityCpdGroupPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivityCpdGroupPermissionQuery, ActivityCpdGroupPermissionQueryVariables>(ActivityCpdGroupPermissionDocument, options);
      }
export function useActivityCpdGroupPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivityCpdGroupPermissionQuery, ActivityCpdGroupPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivityCpdGroupPermissionQuery, ActivityCpdGroupPermissionQueryVariables>(ActivityCpdGroupPermissionDocument, options);
        }
export type ActivityCpdGroupPermissionQueryHookResult = ReturnType<typeof useActivityCpdGroupPermissionQuery>;
export type ActivityCpdGroupPermissionLazyQueryHookResult = ReturnType<typeof useActivityCpdGroupPermissionLazyQuery>;
export type ActivityCpdGroupPermissionQueryResult = Apollo.QueryResult<ActivityCpdGroupPermissionQuery, ActivityCpdGroupPermissionQueryVariables>;